<app-base-template (modal)="openModal(content)" (searchmodal) = "searchModal()" (dataExportToExcel)="exportToExcel()" (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage" [showExportBtn]="showExportBtn" [isExportDisable]="isExportDisable"[showSearch]="showSearch"[dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Add Business Matrix</div>
    <div class="loader" [hidden]="dataLoaded"><img class="loading-gif" src="../../../assets/img/loader.gif"></div>
  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="ticketSelected"
              (change)="onTicketChange($event.target.selectedIndex)">
        <option *ngFor="let ticket of tickets" [value]="ticket.id">{{ticket.name}}</option>
      </select>
    </div>
    <div class="form-group" *ngIf="priorityType===1">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="impactSelected"
              (change)="onImpactChange($event.target.selectedIndex)">
        <option *ngFor="let impact of impacts" [value]="impact.id">{{impact.name}}</option>
      </select>
    </div>
    <div class="form-group" *ngIf="priorityType===1">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="urgencySelected"
              (change)="onUrgencyChange($event.target.selectedIndex)">
        <option *ngFor="let urgency of urgencies" [value]="urgency.id">{{urgency.name}}</option>
      </select>
    </div>
    <div class="form-group" *ngIf="priorityType===2">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="categorySelected"
              (change)="onCategoryChange($event.target.selectedIndex)">
        <option *ngFor="let category of categories" [value]="category.id">{{category.name}}</option>
      </select>
    </div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="prioritySelected"
              (change)="onPriorityChange($event.target.selectedIndex)">
        <option *ngFor="let priority of priorities" [value]="priority.id">{{priority.name}}</option>
      </select>
    </div>

  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>


<ng-template #scarch_content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Search</div>

  </div>
  <div class="modal-body">

      <div class="form-group mar_top">
          <input type="text" class="form-control radius-0 font-13" placeholder=" Enter category Name"
                 [(ngModel)]="catSelected">
      </div>
  </div>
  <div class="modal-footer pad-8">
    
          <button type="button" class="btn btn-success float-right radius-0" (click)="search()">search</button>
          <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>

  </div>

  </ng-template>
<notifier-container></notifier-container>

